import Container from '../../components/Container';

import { Card, Space, Switch, Tabs, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import GoodsOverview from '../../components/analysis/goods/GoodsOverview';
import GoodsDistribution from '../../components/analysis/goods/GoodsDistribution';
import GoodsDetail from '../../components/analysis/goods/GoodsDetail';
import { useState } from 'react';
import { EXTENDED_TIMEOUT } from '../../constants/systemConstants';
import getDashboardStyle from '../../utils/getDashboardStyle';

const GoodsAnalysis = () => {
  //General Components
  const [isSeller, setIsSeller] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  //Data Components
  //Text Components
  const { t } = useTranslation();
  const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout>();

  return (
    <Container>
      <Card bodyStyle={{ minHeight: 250 }}>
        <Space>
          <Typography.Title level={3} style={{ fontWeight: 500 }}>
            {t('analysis.goodsTitle')}
          </Typography.Title>
          {getDashboardStyle().isSellerSwitch && (
            <Switch
              loading={isLoading}
              onChange={(checked) => {
                if (typingTimeout) clearTimeout(typingTimeout);
                setTypingTimeout(
                  setTimeout(() => {
                    setIsSeller(checked);
                  }, EXTENDED_TIMEOUT)
                );
              }}
              style={{ marginBottom: 12 }}
              checkedChildren={t('goods.goodsListColumns.seller')}
              unCheckedChildren={t('goods.goodsListColumns.self')}
            />
          )}
        </Space>
        <Tabs destroyInactiveTabPane defaultActiveKey="1">
          <Tabs.TabPane tab={t(`analysis.goodsOverview.tab1Title`)} key={'1'}>
            <GoodsOverview
              isSeller={isSeller}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={t(`analysis.goodsDistribution.tab2Title`)}
            key={'2'}
          >
            <GoodsDistribution
              isSeller={isSeller}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t(`analysis.goodsDetail.tab3Title`)} key={'3'}>
            <GoodsDetail
              isSeller={isSeller}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </Container>
  );
};

export default GoodsAnalysis;
